import React, { Component } from 'react';
import './Actions.css';

class Actions extends Component {
  render() {
    if (!this.props.isActing) {
      return (<div className="actions"></div>);
    }

    let fold = '';
    let check = '';
    let call = '';
    let bet = '';
    let bringIn = '';
    let raise = '';

    this.props.actions.forEach((action) => {
      switch(action) {
        case 'FOLD':
          fold = (
            <button className="btn-fold" onClick={this.props.onFold}>
              Fold
            </button>
          );
          break;
        case 'CHECK':
          check = (
            <button className="btn-check" onClick={this.props.onCheck}>
              Check
            </button>
          );
          break;
        case 'CALL':
          call = (
            <button className="btn-call" onClick={this.props.onCall}>
              Call
            </button>
          );
          break;
        case 'BET':
          bet = (
            <button className="btn-bet" onClick={this.props.onBet}>
              Bet
            </button>
          );
          break;
        case 'BRING_IN':
          bringIn = (
            <button className="btn-bringin" onClick={this.props.onBringIn}>
              Bring In
            </button>
          );
          break;
        case 'RAISE':
          raise = (
            <button className="btn-raise" onClick={this.props.onRaise}>
              Raise
            </button>
          );
          break;
        default:
          break;
      }
    });

    if (this.props.hide) {
      return (
        <div className="actions"></div>
      );
    }

    return (
      <div className="actions">
        <div className="fold sub-action">
          {fold}
          {check}
        </div>
        <div className="bet sub-action">
          {bet}
          {call}
          {bringIn}
        </div>
        <div className="raise sub-action">
          {raise}
        </div>
      </div>
    );
  }
}

export default Actions;



// WEBPACK FOOTER //
// ./src/Actions.js